import Header from "../components/header/Header";
import React from "react";
import "./LoginError.css";
import NikeLogoImg from "../nike-logo-black.svg"


function LoginError({ requiredGroup }) {
    return <div className="container">
        <Header/>
        <div className="authentication-error">
            <h4 className="title-login-error">Authentication error</h4>
            <span>You are not assigned to the correct group in order to access this application.</span>
            <span className="bold-instructions">Please, follow these instructions:</span>
            <div className="instructions-list">
                <span>1. Go to <a href="https://idlocker.nike.com/" className="eds-link">idlocker.nike.com</a></span>
                <span>2. Request access for the following group - {requiredGroup}</span>
                <span>3. Wait for approval</span>
            </div>
            <img src={NikeLogoImg} alt="Nike Logo" />
        </div>
    </div>
}

export default LoginError